export default "__VITE_ASSET__B_J4ZSo9__"